import React from "react";

function ShipIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
    >
      <path
        d="M3.5 0C2.67188 0 2 0.671875 2 1.5V3H0.5C0.225 3 0 3.225 0 3.5C0 3.775 0.225 4 0.5 4H2H8.5C8.775 4 9 4.225 9 4.5C9 4.775 8.775 5 8.5 5H2H1.5C1.225 5 1 5.225 1 5.5C1 5.775 1.225 6 1.5 6H2H7.5C7.775 6 8 6.225 8 6.5C8 6.775 7.775 7 7.5 7H2H0.5C0.225 7 0 7.225 0 7.5C0 7.775 0.225 8 0.5 8H2H6.5C6.775 8 7 8.225 7 8.5C7 8.775 6.775 9 6.5 9H2V13C2 14.6562 3.34375 16 5 16C6.65625 16 8 14.6562 8 13H12C12 14.6562 13.3438 16 15 16C16.6562 16 18 14.6562 18 13H19C19.5531 13 20 12.5531 20 12C20 11.4469 19.5531 11 19 11V9V8V7.41563C19 6.88438 18.7906 6.375 18.4156 6L16 3.58437C15.625 3.20937 15.1156 3 14.5844 3H13V1.5C13 0.671875 12.3281 0 11.5 0H3.5ZM17 7.41563V8H13V5H14.5844L17 7.41563ZM5 11.5C5.39782 11.5 5.77936 11.658 6.06066 11.9393C6.34196 12.2206 6.5 12.6022 6.5 13C6.5 13.3978 6.34196 13.7794 6.06066 14.0607C5.77936 14.342 5.39782 14.5 5 14.5C4.60218 14.5 4.22064 14.342 3.93934 14.0607C3.65804 13.7794 3.5 13.3978 3.5 13C3.5 12.6022 3.65804 12.2206 3.93934 11.9393C4.22064 11.658 4.60218 11.5 5 11.5ZM13.5 13C13.5 12.6022 13.658 12.2206 13.9393 11.9393C14.2206 11.658 14.6022 11.5 15 11.5C15.3978 11.5 15.7794 11.658 16.0607 11.9393C16.342 12.2206 16.5 12.6022 16.5 13C16.5 13.3978 16.342 13.7794 16.0607 14.0607C15.7794 14.342 15.3978 14.5 15 14.5C14.6022 14.5 14.2206 14.342 13.9393 14.0607C13.658 13.7794 13.5 13.3978 13.5 13Z"
        fill="#2563EB"
      />
    </svg>
  );
}

export default ShipIcon;
